import { Box, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Header from '../../../../shared/components/Header/Header';
import useBlacklistManagement from '../../hooks/useBlacklistManagement';
import { Blacklist } from '../../interfaces/BlacklistType';
import styles from './BlacklistHeader.module.scss';
import { useTranslations } from 'use-intl';

const BlacklistHeader = () => {
  const t = useTranslations('blacklistManagement.header');
  const { setOpen } = useBlacklistManagement();
  const { pathname } = useLocation();
  const isLoyalty = pathname.includes(Blacklist.LOYALTY);

  return (
    <Box id={styles.blacklistHeader}>
      <Header
        title={t('title')}
        description={t('description')}
      />
      {isLoyalty && (
        <Button
          onClick={() => {
            console.log('button clicked');
            setOpen(true);
          }}
        >
          {t('createGroup')}
        </Button>
      )}
    </Box>
  );
};

export default BlacklistHeader;
